/**
 * The lock drawn beside a cancel lock (SSD-7450): the same line icon as the Admin Ultimate Design's LockIcon, one
 * stroke weight in the text colour. master does not carry UltimateIcons yet, so the lock keeps its own copy here.
 * It is decoration only; the badge's own words carry its meaning, so it is hidden from assistive technology.
 */
import type { SVGProps } from 'react';

type IconProps = Omit<SVGProps<SVGSVGElement>, 'children'>;

export const LockIcon = ({ className, ...props }: IconProps) => (
  <svg
    viewBox="0 0 24 24"
    className={['ff-icon', className].filter(Boolean).join(' ')}
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <rect x="5" y="11" width="14" height="10" rx="2" />
    <path d="M8 11V8a4 4 0 0 1 8 0v3" />
  </svg>
);
